import DapAttenteGridController from './dap-attente-grid.controller';

export default {
	template: require('./dap-attente-grid.html'),
	controller: DapAttenteGridController
};
